import { fetchReleaseNotes } from './api/fetchReleaseNotes';
import { releaseNotesKeys } from './queryKeys';

/**
 * Shared query config for release notes. Used by the useReleaseNotes hook and
 * by the _app loader to warm the cache on app load (so the header indicator is
 * ready immediately). Mirrors the meQueryOptions() factory pattern.
 */
export const releaseNotesQueryOptions = () => ({
  queryKey: releaseNotesKeys.all,
  queryFn: ({ signal }: { signal?: AbortSignal }) => fetchReleaseNotes(signal),
  staleTime: 30 * 60 * 1000,
  gcTime: 60 * 60 * 1000,
});
